import {
  SET_CURRENT_FEATURE_LICENCE,
  LICENCE_CREATE_NEW_PARTS_HANDLER,
} from "@/store/actions/licences";
import restrictions from "@/utils/restrictions";
const state = {
  currentFeatureLicence: [],
  availableFeatureLicences: {
    //TODO: Rename enabled and disabled properties to be more describable
    //NOTE: Naming:
    // If the feature has enabled: false and disabled:{true, false} then it is not available and there are no restrictions on using it.
    // If the feature has enabled: true and disabled: false then the feature is available (labeled with star icon).
    // If the feature has enabled: true and disabled: true then the feature is available (labeled with star icon) and it is in read-only state.

    // NOTE: Disabled properties are computed in the handlers (bottom of the code)

    beneteau: [
      {
        id: "template",
        text: "",
        enabled: false,
        disabled: false,
      },
      {
        id: "task-other",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "virtual-qr-generate",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "create-new-parts",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          crm_groups: { roles: [{ items_permission: "WRITE" }] },
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "create-new-documents",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          crm_groups: { roles: [{ documents_permission: "WRITE" }] },
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "custom-protocols",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-part-on-boat",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-part-on-model",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-document-on-boat",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-document-on-model",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-document-on-part",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      // {
      //   id: "unlimited-boats-group-only",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "unlimited-boats-all",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "standard-maintenance-scenarios",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "custom-alerts-reminders",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "channel-to-sell-services",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "task-allocations-to-team-members",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "standard-maintenance-protocols",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "visual-planning",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "custom-checklists",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "allocation-to-external-service-providers",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "one-base",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "unlimited-users",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "unlimited-bases",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
    ],
    sentinel: [
      {
        id: "template",
        text: "",
        enabled: false,
        disabled: false,
      },
      {
        id: "task-other",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "virtual-qr-generate",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "create-new-parts",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          crm_groups: { roles: [{ items_permission: "WRITE" }] },
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "create-new-documents",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          crm_groups: { roles: [{ documents_permission: "WRITE" }] },
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "custom-protocols",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-part-on-boat",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-part-on-model",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-document-on-boat",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-document-on-model",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      {
        id: "add-document-on-part",
        text: "Advanced licence needed",
        enabled: true,
        disabled: false,
        check: {
          dealerships: { licence: { sku: "advanced", name: "Advanced" } },
        },
      },
      // {
      //   id: "unlimited-boats-group-only",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "unlimited-boats-all",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "standard-maintenance-scenarios",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "custom-alerts-reminders",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "channel-to-sell-services",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "task-allocations-to-team-members",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "standard-maintenance-protocols",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "visual-planning",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "custom-checklists",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "allocation-to-external-service-providers",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "one-base",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "unlimited-users",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
      // {
      //   id: "unlimited-bases",
      //   text: "Advanced licence needed",
      //   enabled: true,
      //   disabled: false,
      // },
    ],
  },
};

const getters = {
  checkIfUserCanUseFeature:
    (state, getters) =>
    (feature = null) => {
      return (
        getters.canUserUseLicencedFeatures(feature) &&
        getters.doesTheLicencedFeatureExist(feature)
      );
    },

  canUserUseLicencedFeatures:
    (state, getters) =>
    (feature = null) => {
      //NOTE: if you do not have the feature has_licencing_enabled than you have permission to use the feature
      if (restrictions.canUseCrmFeature("has_licencing_enabled")) return true;

      return false;
    },

  doesTheLicencedFeatureExist:
    (state, getters) =>
    (feature = null) => {
      if (feature === null) return false;

      if (Object.keys(getters.getRequstedFeature(feature)).length !== 0) {
        return true;
      }

      return false;
    },

  getRequstedFeature:
    (state, getters) =>
    (feature = null) => {
      if (feature === null) return {};

      const filteredFeature = state.currentFeatureLicence.find(
        ({ id }) => id === feature
      );

      if (typeof filteredFeature === "undefined") {
        console.error("LICENCES: Licence feature does not exists");
        return {};
      }

      return filteredFeature;
    },

  checkDealershipsForTheAdvancedLicence:
    (state, getters) =>
    (feature = null) => {
      if (feature === null) return false;

      if (
        typeof feature.check === "undefined" ||
        feature.check.length === 0 ||
        typeof feature.check.dealerships === "undefined"
      ) {
        return false;
      }

      if (getters.getMe.dealerships.length === 0) {
        return false;
      }

      return getters.getMe.dealerships.some((dealership) => {
        if (typeof dealership.licence === "undefined") {
          return false;
        }

        return dealership.licence.sku !== feature.check.dealerships.licence.sku;
      });
    },

  checkGroupsForTheWritePermission:
    (state, getters) =>
    (feature = null) => {
      if (feature === null) return true;

      if (
        typeof feature.check === "undefined" ||
        feature.check.length === 0 ||
        typeof feature.check.crm_groups === "undefined"
      ) {
        return true;
      }

      if (getters.getMe.crm_groups.length === 0) {
        return true;
      }

      return !getters.getMe.crm_groups.some((group) => {
        if (group.roles.length === 0) return true;

        return group.roles.some(({ roleKey, roleValue }) => {
          return feature.check.crm_groups.roles.some(
            ({ featureKey, featureValue }) => {
              return roleKey === featureKey && roleValue === featureValue;
            }
          );
        });
      });
    },

  checkDealershipsForTheAdvancedLicenceBasedOnGroup:
    (state, getters) =>
    (groups = []) => {
      if (getters.getMe.dealerships.length === 0 || groups.length === 0) {
        return groups;
      }

      return groups.flatMap((group) => {
        return getters.getMe.dealerships.map((dealership) => {
          if (
            dealership.partner_group.uuid === group.uuid &&
            dealership.licence.sku === "advanced"
          )
            return { ...group, disabled: false };

          return { ...group, disabled: true };
        });
      });
    },

  checkDealershipForTheAdvancedLicenceBasedOnGroup:
    (state, getters) =>
    (group = null) => {
      if (getters.getMe.dealerships.length === 0 || group === null) {
        return false;
      }

      const dealership = getters.getMe.dealerships.find((dealership) => {
        return dealership.partner_group.uuid === group.uuid;
      });

      if (
        typeof dealership === "undefined" ||
        typeof dealership.licence === "undefined"
      ) {
        //NOTE: If there is no dealership found in the getMe, item should be disabled
        return true;
      }
      //NOTE: Negation is present for the disabled property
      return dealership.licence.sku !== "advanced";
    },

  //NOTE: Handlers for the features
  createNewPartsHandler: (state, getters) => {
    const featureObject = getters.getRequstedFeature("create-new-parts");
    const enabled = getters.canUserUseLicencedFeatures();

    if (!enabled) {
      return { ...featureObject, disabled: false, enabled: enabled };
    }

    const disabled =
      getters.checkGroupsForTheWritePermission(featureObject) ||
      getters.checkDealershipsForTheAdvancedLicence(featureObject);

    return { ...featureObject, disabled: disabled, enabled: enabled };
  },

  createNewDocumentsHandler: (state, getters) => {
    const featureObject = getters.getRequstedFeature("create-new-documents");
    const enabled = getters.canUserUseLicencedFeatures();

    if (!enabled) {
      return { ...featureObject, disabled: false, enabled: enabled };
    }

    const disabled =
      getters.checkGroupsForTheWritePermission(featureObject) ||
      getters.checkDealershipsForTheAdvancedLicence(featureObject);

    return { ...featureObject, disabled: disabled, enabled: enabled };
  },

  customProtocolsHandler: (state, getters) => {
    const featureObject = getters.getRequstedFeature("custom-protocols");
    const enabled = getters.canUserUseLicencedFeatures();

    if (!enabled) {
      return { ...featureObject, disabled: false, enabled: enabled };
    }

    const disabled =
      getters.checkDealershipsForTheAdvancedLicence(featureObject);

    return { ...featureObject, disabled: disabled, enabled: enabled };
  },
  disableDealershipsWithoutAdvancedLicenceHandler:
    (state, getters) => (groups) => {
      if (!getters.canUserUseLicencedFeatures()) return groups;

      return getters.checkDealershipsForTheAdvancedLicenceBasedOnGroup(groups);
    },

  disableAddingPartsWithoutAdvancedLicenceHandler:
    (state, getters) =>
    (feautre) =>
    (group) =>
    (item, view = "details") => {
      const computeDisabled = (item, view) => {
        if (item.boat_item_count !== 0 && view !== "details") {
          return false;
        }

        if (!item.is_custom_part) {
          return false;
        }

        return (
          getters.checkDealershipForTheAdvancedLicenceBasedOnGroup(group) &&
          !group.is_supergroup
        );
      };

      const featureObject = getters.getRequstedFeature(feautre);
      const enabled = getters.canUserUseLicencedFeatures();

      if (typeof group === "undefined" || typeof item === "undefined") {
        console.error(
          "LICENCE: disableAddingPartsWithoutAdvancedLicenceHandler, group or item undefined"
        );
        return { ...featureObject, disabled: true, enabled: true };
      }

      if (!enabled) {
        return { ...featureObject, disabled: false, enabled: enabled };
      }

      const disabled = computeDisabled(item, view);

      return { ...featureObject, disabled: disabled, enabled: enabled };
    },

  disableAddingDocumentsWithoutAdvancedLicenceHandler:
    (state, getters) =>
    (feature) =>
    (group) =>
    (item, view = "details") => {
      const computeDisabled = (item, view) => {
        if (item.boat_item_count !== 0 && view !== "details") {
          return false;
        }

        if (!item.is_custom_document) {
          return false;
        }

        return (
          getters.checkDealershipForTheAdvancedLicenceBasedOnGroup(group) &&
          !group.is_supergroup
        );
      };

      const featureObject = getters.getRequstedFeature(feature);
      const enabled = getters.canUserUseLicencedFeatures();

      if (typeof group === "undefined") {
        return { ...featureObject, disabled: true, enabled: true };
      }

      if (!enabled) {
        return { ...featureObject, disabled: false, enabled: enabled };
      }

      const disabled = computeDisabled(item, view);

      return { ...featureObject, disabled: disabled, enabled: enabled };
    },

  generateVirutalDeviceHandler: (state, getters) => (group) => {
    const featureObject = getters.getRequstedFeature("virtual-qr-generate");
    const enabled = getters.canUserUseLicencedFeatures();

    if (!enabled) {
      //NOTE: For sentinel users there are no restrictions on generating virtual devices
      return { ...featureObject, disabled: false, enabled: enabled };
    }

    const disabled =
      getters.checkDealershipsForTheAdvancedLicence(featureObject);

    return { ...featureObject, disabled: disabled, enabled: enabled };
  },

  assignOtherServicingPartnerToTaskHandler: (state, getters) => (group) => {
    const featureObject = getters.getRequstedFeature("task-other");
    const enabled = getters.canUserUseLicencedFeatures();

    if (!enabled) {
      return { ...featureObject, disabled: false, enabled: enabled };
    }

    const disabled =
      getters.checkDealershipsForTheAdvancedLicence(featureObject);

    return { ...featureObject, disabled: disabled, enabled: enabled };
  },

  getDefaultTemplate: (state, getters) => {
    const featureObject = getters.getRequstedFeature("template");

    return { ...featureObject };
  },
};

const actions = {};

const mutations = {
  [SET_CURRENT_FEATURE_LICENCE]: (state, { brandID }) => {
    return;
    // if (!(brandID === "beneteau" || brandID === "sentinel")) {
    //   console.error("LICENCES: Licence is not defined");
    //   return;
    // }
    // state.currentFeatureLicence = state.availableFeatureLicences[brandID];
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
